import {
  Baby, Bike, Book, BookOpen, Briefcase, Building, Building2, Bus, Calendar, CalendarDays, Camera, Car, Church, Coffee, Compass, Cross, Dumbbell, Factory, Fish, Flame,
  Flower2, Fuel, Gem, Gift, GraduationCap, Hammer, Heart, HeartHandshake, HeartPulse, Home, Hospital, Hotel, IceCream, Images, Info, Landmark, Laptop, Leaf, Library, Link,
  MapPin, Megaphone, Mountain, Music, Newspaper, Package, Paintbrush, PartyPopper, PawPrint, Phone, Pill, PlusCircle, Scissors, ScrollText, Search, Shirt, ShoppingBag,
  ShoppingBasket, ShoppingCart, Smartphone, Sparkles, Sprout, Star, Stethoscope, Store, Sun, Tag, Tent, Train, Trees, Trophy, Truck, Tv, Users, UtensilsCrossed, Waves,
  Wheat, Wrench, Zap, Plane, Banknote, Scale, Shield, Ship, type LucideIcon,
} from 'lucide-react';

/**
 * Curated icon set available to admins for categories, menus and link grids.
 * Keeping it curated avoids shipping the full icon library to every visitor.
 */
export const ICONS: Record<string, LucideIcon> = {
  Baby, Bike, Book, BookOpen, Briefcase, Building, Building2, Bus, Calendar, CalendarDays, Camera, Car, Church, Coffee, Compass, Cross, Dumbbell, Factory, Fish, Flame,
  Flower2, Fuel, Gem, Gift, GraduationCap, Hammer, Heart, HeartHandshake, HeartPulse, Home, Hospital, Hotel, IceCream, Images, Info, Landmark, Laptop, Leaf, Library, Link,
  MapPin, Megaphone, Mountain, Music, Newspaper, Package, Paintbrush, PartyPopper, PawPrint, Phone, Pill, PlusCircle, Scissors, ScrollText, Search, Shirt, ShoppingBag,
  ShoppingBasket, ShoppingCart, Smartphone, Sparkles, Sprout, Star, Stethoscope, Store, Sun, Tag, Tent, Train, Trees, Trophy, Truck, Tv, Users, UtensilsCrossed, Waves,
  Wheat, Wrench, Zap, Plane, Banknote, Scale, Shield, Ship,
};

export const ICON_NAMES = Object.keys(ICONS).sort();

export function Icon({ name, className }: { name?: string; className?: string }) {
  const C = (name && ICONS[name]) || Tag;
  return <C className={className} aria-hidden />;
}
